export default __webpack_public_path__ + "static/media/Cheffy logo.f4433f09.jpg";